import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { MessageService } from '@letly/ui-common';

export interface HasUnsavedChanges {
  hasUnsavedChanges(): boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (component) => {
  const messageService = inject(MessageService);

  if (!component?.hasUnsavedChanges?.()) return true;

  return messageService.showConfirmation(
    $localize`:@@core.unsaved-changes.title:Leave without saving?`,
    $localize`:@@core.unsaved-changes.message:Your changes to this contract haven’t been saved. If you leave now they will be lost.`,
    true,
    false,
    $localize`:@@core.unsaved-changes.confirm:Leave and discard`,
    $localize`:@@core.unsaved-changes.cancel:Keep editing`,
    'error',
  );
};
